/* ════════════════════════════════════════════════════════════════
   Tessera Diamonds — Cart page quantity steppers.
   Adjust the quantity input then debounce-submit the Shopify cart form
   (a no-submitter submit = an "update", recalculating totals server-side).
   Remove links (item.url_to_remove) work without JS as a fallback.
   ════════════════════════════════════════════════════════════════ */
(function () {
  const form = document.getElementById('td-cart-form');
  if (!form) return;

  let timer;
  function scheduleUpdate() {
    clearTimeout(timer);
    timer = setTimeout(() => {
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    }, 450);
  }

  form.querySelectorAll('[data-cart-line]').forEach(line => {
    const input = line.querySelector('.cart-qty__input');
    if (!input) return;
    const down = line.querySelector('[data-qty-down]');
    const up = line.querySelector('[data-qty-up]');

    function step(delta) {
      let v = parseInt(input.value, 10);
      if (isNaN(v)) v = 0;
      v = Math.max(0, v + delta);
      input.value = v;
      scheduleUpdate();
    }
    if (down) down.addEventListener('click', () => step(-1));
    if (up) up.addEventListener('click', () => step(1));
    input.addEventListener('change', () => {
      if (parseInt(input.value, 10) < 0 || isNaN(parseInt(input.value, 10))) input.value = 0;
      scheduleUpdate();
    });
  });
})();
